import React, { useState, useEffect } from 'react';
import './Header.css';

function Header({ activePage }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(activePage || '');

  useEffect(() => {
    if (activePage) {
      setCurrentPage(activePage);
    } else {
      setCurrentPage('');
    }
  }, [activePage]);

  const handleNavigation = (page, e) => {
    e.preventDefault();
    if (window.navigateTo) {
      window.navigateTo(page);
      setMenuOpen(false);
      setCurrentPage(page);
      window.scrollTo(0, 0);
    }
  };

  const isActive = (page) => {
    return currentPage === page ? 'active' : '';
  };

  return (
    <header className="header">
      {/* Overlay pour fermer le menu mobile */}
      {menuOpen && (
        <div 
          className="menu-overlay" 
          onClick={() => setMenuOpen(false)}
        ></div>
      )}
      
      <div className="container">
        <div className="header-content">
          {/* Logo et Ministère */}
          <div className="header-left">
            <div className="logo-circle" onClick={(e) => handleNavigation('home', e)} style={{cursor: 'pointer'}}>
              <img src="/images/logo-gsu.png" alt="GSU Les Palmiers" />
            </div>
            
            {/* Image complète du ministère remplaçant le badge blanc */}
            <div className="ministry-image" onClick={(e) => handleNavigation('home', e)} style={{cursor: 'pointer'}}>
              <img src="/images/armoiries-benin-header.png" alt="République du Bénin - Fraternité Justice Travail" />
            </div>
          </div>

          {/* Navigation */}
          <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
            <a href="/" onClick={(e) => handleNavigation('home', e)} className={isActive('home')}>Accueil</a>
            <a href="/" onClick={(e) => handleNavigation('about', e)} className={isActive('about')}>À propos</a>
            <a href="#filieres" onClick={(e) => handleNavigation('filieres', e)} className={isActive('filieres')}>Filières</a>
            
            {/* Dropdown Projets */}
            <div 
              className="dropdown"
              onMouseEnter={() => setDropdownOpen(true)}
              onMouseLeave={() => setDropdownOpen(false)}
            >
              <a 
                href="#projets" 
                onClick={(e) => handleNavigation('projets', e)} 
                className={`dropdown-link ${isActive('projets')}`}
              >
                Projets
              </a>
              {dropdownOpen && (
                <div className="dropdown-menu">
                  <a href="#opportunites" onClick={(e) => handleNavigation('opportunites', e)}>Opportunités</a>
                </div>
              )}
            </div>
            
            <a href="#actualites" onClick={(e) => handleNavigation('actualites', e)} className={isActive('actualites')}>Actualités</a>
            <a href="#documents-utiles" onClick={(e) => handleNavigation('documents-utiles', e)} className={isActive('documents-utiles')}>Fournitures & Horaires</a>
            <a href="#contact" onClick={(e) => handleNavigation('contact', e)} className={isActive('contact')}>Contact</a>
          </nav>

          {/* Boutons et Menu mobile */}
          <div className="header-buttons">
            <button 
              className="btn-connect"
              onClick={(e) => {
                e.preventDefault();
                handleNavigation('login', e);
              }}
            >
              Se connecter
            </button>
            
            {/* Menu mobile */}
            <button 
              className="menu-toggle" 
              onClick={() => setMenuOpen(!menuOpen)}
            >
              ☰
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
